import { useState } from "react";
import { useChat } from "../zustand/ChatZustand";
import { Warnung } from "./Symbole";

/*
  Der Wiederherstellungsschlüssel — einmal und nie wieder.

  Er erscheint genau dann, wenn die Verschlüsselung zum ersten Mal
  eingerichtet wurde. Danach ist er weg: Ihn aufzubewahren hieße, eine zweite
  Kopie an derselben Stelle zu lagern, die er absichern soll.

  Warum das überhaupt sein muss: Die Chatbeiträge liegen verschlüsselt auf
  dem Server, und die Schlüssel dazu im Browser. Wer den Browserspeicher
  löscht oder ein neues Gerät nimmt, kommt ohne diesen Schlüssel nie wieder
  an alte Beiträge — auch wir nicht. Das ist der Preis dafür, dass niemand
  mitlesen kann.

  Bewusst kein „Später erinnern“: Wer wegklickt, ohne zu speichern, hat den
  Schlüssel verloren. Deshalb muss man ausdrücklich bestätigen.
*/

export default function Wiederherstellungsschluessel() {
  const chat = useChat();
  const [kopiert, setzeKopiert] = useState(false);
  const [bestaetigt, setzeBestaetigt] = useState(false);

  /*
    Zwei Fälle, ein Fenster: Entweder es gibt einen Schlüssel zu notieren —
    oder die Sicherung ist gescheitert, und dann muss man das erfahren. Beim
    ersten Versuch wurde der Fehler verschluckt; aufgefallen wäre er erst,
    wenn jemand sein Gerät verliert und der Verlauf weg ist.
  */
  if (!chat.wiederherstellung && !chat.kryptofehler) return null;

  if (chat.kryptofehler) {
    return (
      <div className="ueberlagerung" role="dialog" aria-label="Schlüsselsicherung fehlgeschlagen">
        <div className="ueberlagerung__karte">
          <div className="ueberlagerung__warnung">
            <p style={{ display: "flex", gap: "var(--luft-3)", alignItems: "flex-start" }}>
              <Warnung groesse={20} />
              <span>
                <strong>Die Schlüsselsicherung konnte nicht eingerichtet werden.</strong> Der Chat
                funktioniert trotzdem. Aber wenn du dieses Gerät verlierst oder den Speicher deines
                Browsers löschst, sind deine bisherigen Chatbeiträge endgültig weg — auch wir
                können sie nicht wiederherstellen.
              </span>
            </p>
          </div>

          <p className="klein leise" style={{ marginTop: "var(--luft-4)" }}>
            Bitte gib diese Meldung weiter:
          </p>
          <p className="schluessel" style={{ marginTop: "var(--luft-2)", fontSize: "var(--schrift-klein)" }}>
            {chat.kryptofehler}
          </p>

          <button
            className="knopf knopf--breit"
            style={{ marginTop: "var(--luft-4)" }}
            onClick={chat.schluesselNotiert}
          >
            Verstanden, weiter
          </button>
        </div>
      </div>
    );
  }

  async function kopieren() {
    try {
      await navigator.clipboard.writeText(chat.wiederherstellung);
      setzeKopiert(true);
    } catch {
      /* Ohne Zwischenablage bleibt der Text zum Abschreiben stehen. */
    }
  }

  return (
    <div className="ueberlagerung" role="dialog" aria-label="Wiederherstellungsschlüssel">
      <div className="ueberlagerung__karte">
        <div className="ueberlagerung__warnung">
          <p style={{ display: "flex", gap: "var(--luft-3)", alignItems: "flex-start" }}>
            <Warnung groesse={20} />
            <span>
              <strong>Schreib diesen Schlüssel auf.</strong> Er ist die einzige Möglichkeit, an
              deine Chatbeiträge zu kommen, wenn du dieses Gerät verlierst oder den Speicher
              deines Browsers löschst. Auch wir können dir dann nicht helfen — die Beiträge sind
              verschlüsselt, und wir können sie nicht lesen.
            </span>
          </p>
        </div>

        <p className="schluessel" style={{ marginTop: "var(--luft-4)" }}>
          {chat.wiederherstellung}
        </p>

        <div className="leiste__knoepfe" style={{ marginTop: "var(--luft-3)" }}>
          <button className="knopf knopf--zurueckhaltend" onClick={kopieren}>
            {kopiert ? "Kopiert" : "Kopieren"}
          </button>
        </div>

        <label className="schluessel__haken">
          <input
            type="checkbox"
            checked={bestaetigt}
            onChange={(e) => setzeBestaetigt(e.target.checked)}
          />
          <span>Ich habe den Schlüssel an einem sicheren Ort notiert.</span>
        </label>

        <button
          className="knopf knopf--breit"
          style={{ marginTop: "var(--luft-3)" }}
          disabled={!bestaetigt}
          onClick={chat.schluesselNotiert}
        >
          Fertig
        </button>
      </div>
    </div>
  );
}
